export const getGlobalStyles = (bodyBackgroundColor: string) => ({
  'html body': { backgroundColor: bodyBackgroundColor },
});
